/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiIncrementalityControlGroupType;
(function (ApiIncrementalityControlGroupType) {
    ApiIncrementalityControlGroupType["INCREMENTALITY_CONTROL_GROUP_TYPE_UNSPECIFIED"] = "IncrementalityControlGroupTypeUnspecified";
    ApiIncrementalityControlGroupType["INCREMENTALITY_CONTROL_GROUP_TYPE_AUTO_MATCHED"] = "IncrementalityControlGroupTypeAutoMatched";
    ApiIncrementalityControlGroupType["INCREMENTALITY_CONTROL_GROUP_TYPE_REST_OF_COUNTRY"] = "IncrementalityControlGroupTypeRestOfCountry";
    ApiIncrementalityControlGroupType["INCREMENTALITY_CONTROL_GROUP_TYPE_CUSTOM"] = "IncrementalityControlGroupTypeCustom";
})(ApiIncrementalityControlGroupType || (ApiIncrementalityControlGroupType = {}));
export function ApiIncrementalityControlGroupTypeFromJSON(json) {
    return ApiIncrementalityControlGroupTypeFromJSONTyped(json, false);
}
export function ApiIncrementalityControlGroupTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiIncrementalityControlGroupTypeToJSON(value) {
    return value;
}
